import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/privacy" className="footer-link">
            Privacy Policy
          </Link>
          <span className="footer-dot">•</span>
          <Link to="/terms" className="footer-link">
            Terms of Use
          </Link>
        </div>
        <p className="footer-copyright">
          © 2025 APPCORE LABS LIMITED
        </p>
      </div>
    </footer>
  );
}